import styled from 'styled-components';

import { Label, Wrapper } from 'src/components/Input/styled';

export const PasswordFieldWrapper = styled(Wrapper)``;

export { Label };

export const InputShell = styled.div<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  height: 2.81rem;
  box-sizing: border-box;
  border-radius: 0.5rem;
  border: 1px solid ${({ theme }) => theme.grey};
  background-color: ${({ theme, $disabled }) => ($disabled ? theme.lightGrey : theme.background)};
  transition: all 0.3s ease;

  &:hover:not(:has(input:disabled)) {
    border-color: ${({ theme }) => theme.midGrey};
  }

  &:focus-within {
    border-color: ${({ theme }) => theme.primary || '#007bff'};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.lightGrey};
  }

  &:has(input:disabled) {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const PasswordFieldInput = styled.input`
  flex: 1;
  min-width: 0;
  height: 100%;
  border: none;
  outline: none;
  padding: 0 0.5rem 0 1rem;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.dark};
  background: transparent;
  cursor: inherit;

  &::placeholder {
    color: ${({ theme }) => theme.midGrey};
    opacity: 0.6;
  }

  &:disabled {
    cursor: not-allowed;
    color: ${({ theme }) => theme.midGrey};
  }
`;

export const ToggleButton = styled.button`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  margin-right: 0.25rem;
  padding: 0;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
  color: ${({ theme }) => theme.midGrey};
  background: transparent;
  transition:
    color 0.15s ease,
    background 0.15s ease;

  &:hover:not(:disabled) {
    color: ${({ theme }) => theme.dark};
    background: ${({ theme }) => theme.lightGrey};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.primary};
    outline-offset: 1px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
